import React from 'react';

// Маленькая иконка "головы" игрока по нику — рендерится напрямую в браузере
// через публичный сервис minotar.net, без обращения к нашему серверу.
function PlayerAvatar({ nickname, size = 32, rounded = 6, style }) {
  if (!nickname) return null;

  return (
    <img
      src={`https://minotar.net/avatar/${encodeURIComponent(nickname)}/${size}.png`}
      alt=""
      width={size}
      height={size}
      style={{
        borderRadius: rounded,
        imageRendering: 'pixelated',
        flexShrink: 0,
        display: 'inline-block',
        ...style
      }}
      onError={(e) => { e.target.style.visibility = 'hidden'; }}
    />
  );
}

export default PlayerAvatar;
